import templateUrl from './publishingAtAGlanceOnHold.html';
import './publishingAtAGlanceOnHold.scss';

import {createLogger} from '../../../common/logging.config';
const logger = createLogger('publishing-at-a-glance-on-hold');

class PublishingAtAGlanceOnHoldController {
	constructor($rootScope, $scope, publishingService) {
		this.$rootScope = $rootScope;
		this.$scope = $scope;
		this.publishingService = publishingService;
		this.entries = [];


        // fetch current publishing on hold items
		this.fetchOnHoldPublishingJobs();
        
		// listen for the event to apply new preferences
		const handler = $rootScope.$on('apply-preferences', (event, payload) => {
			this.fetchOnHoldPublishingJobs();
		});
		$scope.$on('$destroy', handler);
		
	}
	
	fetchOnHoldPublishingJobs() {
        this.publishingService.getCurrentOnHold().then(
    		(data) =>  {
	        	this.entries = data;
	        	this.$scope.$apply();
    		}
		);
	}
}

export default {
	controller: [ '$rootScope', '$scope', 'publishingService', PublishingAtAGlanceOnHoldController ],
	templateUrl
};



// WEBPACK FOOTER //
// ./app/components/publishingAtAGlance/publishingAtAGlanceOnHold/publishingAtAGlanceOnHold.component.js